import { actions } from './reducer';
/** Read back by the save widget to preselect the integration the user last saved to. */
const LAST_INTEGRATION_SAVED_KEY = 'lastIntegrationSaved';
class Dispatch {
    constructor() {
        this.actions = actions;
    }
    openSaveToCrmPopup(options) {
        return dispatch => {
            if (options.selectedIntegration) {
                localStorage.setItem(LAST_INTEGRATION_SAVED_KEY, JSON.stringify({ name: options.selectedIntegration }));
            }
            dispatch(actions.showSaveToCrmPopup(options));
        };
    }
}
const PopupsDispatcher = new Dispatch();
export default PopupsDispatcher;
